import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, Observable } from '../common';
import { AppConstants } from '../common/constants';
import { ISubscriptionResponse, ISubscriptionsResponse } from '../models/responses';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionService {

  constructor(private httpClient: HttpClient) { }

  GetAllSubscriptions(): Observable<ISubscriptionsResponse>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/SubsCriptions/Get`;
    
    return this.httpClient.get<ISubscriptionsResponse>(url, { headers });
  }

  GetById(_id: number): Observable<ISubscriptionResponse>{
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    const url = `${AppConstants.API_URL}api/SubsCriptions/GetSub?id=${_id}`;
    
    return this.httpClient.get<ISubscriptionResponse>(url, { headers });
  }
}
